import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn("skeleton-shimmer rounded-md bg-slate-200", className)}
      {...props} />
  );
}

export { Skeleton }
